import { Vertical } from "@/components/standard/BFLayout"
import { EstimatedTotalsNoContext } from "@/screens/loans/components/EstimatedTotalsSection"
import { LoanDetailsDisclaimer } from "@/screens/loans/components/LoanDetailsDisclaimer"
import {
  BorrowerDetailSection,
  ContractDetailSection,
  LoanDetailsSection,
  PropertyInfoSection,
} from "@/screens/loans/components/dashboard/LoanDetails"

import { useQuery } from "@tanstack/react-query"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import LoanDashboardDetailsLayout from "@/screens/loans/components/dashboard/layouts/LoanDashboardDetailsLayout"

export default function LoanDashboardDetailsScreen({
  loanId,
}: {
  loanId: string
}) {
  const loanApplicationQuery = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      if (!data) {
        return null
      }

      return data
    },
  })

  const loanApplication = loanApplicationQuery.data

  if (!loanApplication) {
    return null
  }

  return (
    <LoanDashboardDetailsLayout loanId={loanId}>
      <Vertical>
        <Vertical className="p-4 pb-1 my-0">
          <LoanDetailsDisclaimer />
        </Vertical>
        <Vertical className={"p-4 gap-4"}>
          <BorrowerDetailSection loanId={loanId} />
          <ContractDetailSection loanId={loanId} />
          <PropertyInfoSection loanId={loanId} />
          <LoanDetailsSection loanId={loanId} />
          <EstimatedTotalsNoContext loanApplication={loanApplication} />
        </Vertical>
      </Vertical>
    </LoanDashboardDetailsLayout>
  )
}
